import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=20d9e3e6&scoped=true&"
import script from "./FormDialog.vue?vue&type=script&lang=js&"
export * from "./FormDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormDialog.vue?vue&type=style&index=0&id=20d9e3e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9e3e6",
  null
  
)

export default component.exports